import kamala from '../../kamala'
import Badge from './Badge'

Badge.install = function (Vue) {
  kamala(Vue)

  Vue.component(Badge.name, Badge)
}

export default Badge
